import Vue from "vue";
import VueRouter from "vue-router";
import { canNavigate } from "@/libs/acl/routeProtection";
import {
  isUserLoggedIn,
  getUserData,
  getHomeRouteForLoggedInUser,
} from "@/auth/utils";
import inside from "./routes/inside";
import auth from "./routes/auth";
import main from "./routes/main";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [...inside, ...auth, ...main],
});

// router.beforeEach((to, _, next) => {
//   const isLoggedIn = isUserLoggedIn();

//   if (!canNavigate(to)) {
//     // Redirect to login if not logged in
//     //if (!isLoggedIn) return next({ name: "auth-login" });

//     // If logged in => not authorized
//     // return next({ name: "misc-not-authorized" });
//   }

router.beforeEach((to, _, next) => {
  // const isLoggedIn = isUserLoggedIn();

  // if (!canNavigate(to)) {
  //   // Redirect to login if not logged in
  //   // if (!isLoggedIn) return next({ name: "auth-login" });

  //   // If logged in => not authorized
  //   // return next({ name: "misc-not-authorized" });
  // }

  // Redirect if logged in
  if (to.meta.redirectIfLoggedIn && isUserLoggedIn()) {
    const userdata = getUserData();
    next(getHomeRouteForLoggedInUser(userdata ? userdata.role : null));
  }

  return next();

  // Redirect if logged in
  if (to.meta.redirectIfLoggedIn && isLoggedIn) {
    const userdata = getUserData();
    next(getHomeRouteForLoggedInUser(userdata ? userdata.role : null));
  }

  return next();
});

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach((to) => {
  // Setup Page title
  document.title = to.meta.title || to.name;
  // Update the meta description
  const metaDescription = document.querySelector('meta[name="description"]');
  if (metaDescription) {
    metaDescription.setAttribute("content", to.meta.description || "");
  }

  // Remove initial loading
  const appLoading = document.getElementById("loading-bg");
  if (appLoading) {
    appLoading.style.display = "none";
  }
});

export default router;
